export const getInputTypeName = inputType => {
  switch (inputType) {
    case 'directly':
      return 'utils.Enum.Directly_edited';
    case 'csv_upload':
      return 'utils.Enum.Csv_Upload';
    case 'first_insert':
      return 'utils.Enum.Not_entered';
    case 'sync_with_jobcan':
      return 'utils.Enum.Jobcan_Attendance_Update';
    case 'sync_with_api_server':
      return 'utils.Enum.Sync_with_API_Server';
    default:
      return 'utils.Enum.Unknown';
  }
};

export default getInputTypeName;
